<template>
  <PageTable />
</template>
<script>
import PageTable from './table'
export default {
  name: 'ecom-sys-transformTemplate',
  components: { PageTable },
}
</script>
